export default __webpack_public_path__ + "static/media/b12.fdb1b36c.pdf";